import { ContractDetailModel } from '@urbanx/agx-ui-components'
import CampaignsService from 'services/campaignsService'

const getContractById = async (
  getAuthToken: () => Promise<string>,
  contractId?: string
): Promise<ContractDetailModel | undefined> => {
  if (!contractId) return

  const token = await getAuthToken()
  const service = new CampaignsService(token)
  
  const result = await service.campaignsService.get('StaffGetContract', {
    ContractId: contractId,
  })

  return result.data
}

export default getContractById
